import { findMergeTokens } from '@/lib/email/oneoff-merge';
import type { ToRecipient } from './ToContactPicker';

export type TemplateRoute = 'raw' | 'populate' | 'no-contact';

export function decideTemplateRoute(
  template: { subject: string; body: string },
  to: ToRecipient,
): TemplateRoute {
  const hasTokens =
    findMergeTokens(template.subject).length > 0 || findMergeTokens(template.body).length > 0;
  if (!hasTokens) return 'raw';
  return to && to.kind === 'contact' ? 'populate' : 'no-contact';
}
